import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './inspection-item-performed.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionItemPerformedDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const inspectionItemPerformedEntity = useAppSelector(state => state.inspectionItemPerformed.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="inspectionItemPerformedDetailsHeading">
          <Translate contentKey="fleetSenseApp.inspectionItemPerformed.detail.title">InspectionItemPerformed</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{inspectionItemPerformedEntity.id}</dd>
          <dt>
            <span id="satisfied">
              <Translate contentKey="fleetSenseApp.inspectionItemPerformed.satisfied">Satisfied</Translate>
            </span>
          </dt>
          <dd>{inspectionItemPerformedEntity.satisfied ? 'true' : 'false'}</dd>
          <dt>
            <span id="observations">
              <Translate contentKey="fleetSenseApp.inspectionItemPerformed.observations">Observations</Translate>
            </span>
          </dt>
          <dd>{inspectionItemPerformedEntity.observations}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="fleetSenseApp.inspectionItemPerformed.image">Image</Translate>
            </span>
          </dt>
          <dd>
            {inspectionItemPerformedEntity.image ? (
              <div>
                {inspectionItemPerformedEntity.imageContentType ? (
                  <a onClick={openFile(inspectionItemPerformedEntity.imageContentType, inspectionItemPerformedEntity.image)}>
                    <img
                      src={`data:${inspectionItemPerformedEntity.imageContentType};base64,${inspectionItemPerformedEntity.image}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {inspectionItemPerformedEntity.imageContentType}, {byteSize(inspectionItemPerformedEntity.image)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspectionItemPerformed.inspectionItem">Inspection Item</Translate>
          </dt>
          <dd>{inspectionItemPerformedEntity.inspectionItem ? inspectionItemPerformedEntity.inspectionItem.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspectionItemPerformed.inspectionHistory">Inspection History</Translate>
          </dt>
          <dd>{inspectionItemPerformedEntity.inspectionHistory ? inspectionItemPerformedEntity.inspectionHistory.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/inspection-item-performed" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/inspection-item-performed/${inspectionItemPerformedEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InspectionItemPerformedDetail;
